module.exports = __webpack_public_path__ + "img/enamad2.56ceed79.png";